import { fetchWithToken } from "../platform-core";
import { CORE_BFF_BASE_URL } from "./constants";

interface OneAdminFeatures {
  [key: string]: boolean;
}

let oneAdminFeatures: Promise<OneAdminFeatures>;

export async function isOneAdminFeatureEnabled(key: string) {
  if (!oneAdminFeatures) {
    oneAdminFeatures = fetchWithToken(`${CORE_BFF_BASE_URL}/v1/my/one-admin-features`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(JSON.stringify(response));
        }

        return response.json();
      })
      .then((oneAdminFeaturesArray: string[]) => {
        const oneAdminFeatures: OneAdminFeatures = {};

        for (const oneAdminFeatureKey of oneAdminFeaturesArray) {
          oneAdminFeatures[oneAdminFeatureKey] = true;
        }

        return oneAdminFeatures;
      });
  }

  return await oneAdminFeatures
    .then((oneAdminFeatures) => oneAdminFeatures.hasOwnProperty(key))
    .catch((error) => {
      console.error(`one-admin-features failed: ${JSON.stringify(error)}`);
      throw new Error("one-admin-features failed");
    });
}
